import {
	ContainsDropOversWrapper,
	Portal
} from "client/Components";
import { isNotNil } from "client/Misc/utils";
import { ReactElement } from "react";
import { BookmarksPageContent } from "./BookmarksPageContent";
import { BookmarksSideBarMenu } from "./BookmarksSideBarMenu";
import { DocumentStoreType } from "client/Api/Documents/common";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { IStoreHistoryState } from "client_legacy/Documents/documentStore";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import { DocumentLayoutKind } from "client/Api/Documents/documents";

export type BookmarksStoreProps = {
	navigationState: BookmarkHistoryState | undefined;
	onChangeNavigationState(state: IStoreHistoryState): void;
	sideBarContainer: HTMLElement;
	onSideBarNavigation(): void;
	onDoesSidebarContainDropOversChange(value: boolean): void;
	layoutKind: DocumentLayoutKind;
	onLayoutKindChange(kind: DocumentLayoutKind): void;
};

export const BookmarksStore = (
	props: BookmarksStoreProps
): ReactElement => {
	const {
		navigationState,
		onChangeNavigationState,
		sideBarContainer,
		onSideBarNavigation,
		onDoesSidebarContainDropOversChange,
		layoutKind,
		onLayoutKindChange
	} = props;

	const isActive: boolean = isNotNil(navigationState);
	const isMobile: boolean = useWorkspaceMediaQuery(MediaQueryKind.Mobile);

	const selectBookmarksHandler = () => {
		onChangeNavigationState({
			store: DocumentStoreType.Bookmarks
		});
		onSideBarNavigation();
	};

	return (
		<>
			<Portal container={sideBarContainer}>
				<ContainsDropOversWrapper onDoesContainDropOversChange={onDoesSidebarContainDropOversChange}>
					<BookmarksSideBarMenu
						isSelected={isActive}
						onClick={selectBookmarksHandler}
					/>
				</ContainsDropOversWrapper>
			</Portal>
			{isActive && (
				<BookmarksPageContent
					isMobile={isMobile}
					onChangeNavigationState={onChangeNavigationState}
					layoutKind={layoutKind}
					onLayoutKindChange={onLayoutKindChange}
				/>
			)}

		</>
	);
};

BookmarksStore.displayName = "BookmarksStore";

export interface BookmarkHistoryState {
	store: DocumentStoreType.Bookmarks;
}

export function createBookmarksUrlFromState(state: IStoreHistoryState): string {
	if (state.store !== DocumentStoreType.Bookmarks) {
		throw new Error("State is not for Bookmarks");
	}

	return createUrlRelativeToEnvironment("/Documents?store=Bookmarks");
}